import primaryButton from '../../../../primary-button';

const light = (params) => primaryButton.solidIcon.background.default.light(params);

export default light;
